import { css } from '@inter-ikea-kompis/web-component';
export default class FinancialServicesButtonsStyle {
    /**
     * Returns styles.
     *
     * @param options Options Object.
     * @param options.theme Theme.
     * @returns Styles.
     */
    static getStyle(options) {
        const { spacing, color } = options.theme;
        return css `
			:host {
				display: flex;
				width: 100%;
			}

			.buttonContainer {
				display: flex;
				flex-grow: 1;
				flex-direction: column;
			}

			.info-button {
				margin-bottom: ${spacing.space100 / 16}rem;
			}

			.qr-code {
				margin: ${spacing.space100 / 16}rem 0 ${spacing.space150 / 16}rem 0;
				display: flex;
				flex-direction: column;
			}

			kompis-qr-code {
				width: 6.7rem;
				margin: 0 auto;
				background-color: ${color.neutral.white};
			}

			.qr-code-text {
				margin-top: ${spacing.space50 / 16}rem;
				color: ${color.text.dark};
				text-align: center;
			}
		`;
    }
}
//# sourceMappingURL=FinancialServicesButtonsStyle.js.map